import { MigrationInterface, QueryRunner } from 'typeorm'

export class AddScheduleSettings1697714124963 implements MigrationInterface {
	name = 'AddScheduleSettings1697714124963'

	public async up(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "settings" ADD "scheduleSettings" json`)
	}

	public async down(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "settings" DROP COLUMN "scheduleSettings"`)
	}
}
